export const isEven = (value: number): boolean => value % 2 === 0

export default isEven
